export const SET = 'dashboard/SET';
export const REQUEST = 'dashboard/REQUEST';
export const RECEIVE = 'dashboard/RECEIVE';
export const ERROR = 'dashboard/ERROR';
